import { config } from '@config';

export function environment() {
    return process.env.NODE_ENV;
}

export function isDevelopment() {
    return environment() === 'development';
}

export function isNotProduction() {
    return environment() !== 'production';
}

/** Build identity (release tag), when known. */
export function appVersion() {
    return config.version;
}

/** Deployment environment the backends belong to ('dev', 'staging', 'production', …). */
export function appEnv() {
    return config.environment;
}
